import React from "react";
import Banner from "../../../../components/Banner";
import "../../../../assets/styles/career.scss";
import SubjectCards from "./SubjectCards";
import BottomBar from "../../../../components/BottomBar";
import { Bell } from "react-feather";

import { Col, Container, Button, Row } from "reactstrap";

const Economics = () => {
  const handleClick = () => {
    console.log("test");
  };
  return (
    <React.Fragment>
      <Banner title="경제 상식은 요즘 필수" bg="economics_banner.jpg" />
      <Container className="subject_container">
        <Row mb={3}>
          <Col md={6} sm={12}>
            <h2>경제학자란?</h2>
            <p>
              경제학자는 경제 분야에서 전문 지식을 가진 사람으로 가장 간단하게
              설명됩니다. 대부분의 경우, 이 전문 지식은 수년간의 학업 환경과
              실제 경험을 통해 얻은 후에 얻습니다. 일반적으로 경제학자 직책을
              가진 특정 직업은 없습니다. 그 대신, 직업은 경제 분석가나 컨설팅 등
              다른 여러 분야에서 일할 수 있는 능력을 갖추고 있습니다.
            </p>
          </Col>
          <Col md={6} sm={12}>
            <img
              src={require("../../../../assets/img/economics_explain.jpg")}
              className="horizontal"
              alt="ucas_official"
            />
          </Col>
        </Row>
        <Row mb={3}></Row>
        <hr className="mt-4 mb-4" />

        <div className="compulsory-subjects">
          <Row className="mb-3">
            <Col md={8}>
              <h3 className="heading section-title">수강해야 하는 과목 </h3>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="mb-4">
              <SubjectCards title="Maths" img="maths.png" />
            </Col>
            <Col md={3}>
              <SubjectCards title="Further Maths" img="further_maths.png" />
            </Col>
            <Col md={3}>
              <SubjectCards title="Economics" img="economics.png" />
            </Col>
            <Col md={3} className="mb-4">
              <SubjectCards title="Optinal" img="chemistry.png" />
            </Col>
          </Row>
        </div>
      </Container>
      <BottomBar>
        <Row>
          <Col md={8} sm={12}>
            <div className="d-inline-block">
              <Bell style={{ position: "relative", bottom: "10" }} />
            </div>
            <div className="d-inline-block pl-2">
              <p style={{ fontWeight: "700" }}>
                EARLY BIRD <span style={{ fontWeight: "900" }}>20%</span> 특별
                할인 이벤트!
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                8월 24일 전에 신청하시면 할인 혜택을 받으실수 있습니다.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <Button
              color="danger"
              style={{ width: "100%" }}
              onClick={handleClick}
            >
              수강 신청하기
            </Button>
          </Col>
        </Row>
      </BottomBar>
    </React.Fragment>
  );
};

export default Economics;
